import { GridApi } from '@ag-grid-community/core'
import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'

@Injectable()
export class CopyService {
  grid!: GridApi

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  readonly copyBinding = this.copyHandler.bind(this)

  /**
   * copy handler on ctrl + c
   */
  copyHandler(event: ClipboardEvent) {
    const cellRanges = this.grid.getCellRanges()
    if (cellRanges && cellRanges.length == 1) {
      const data: string[] = []
      const range = cellRanges[0]
      let startRow = range.startRow?.rowIndex ?? 0
      let endRow = range.endRow?.rowIndex ?? 0
      // Swap indices if selection was made in reverse order (bottom-to-top)
      if (startRow > endRow) [startRow, endRow] = [endRow, startRow]

      for (let i = startRow; i <= endRow; i++) {
        const rowData: string[] = []
        range.columns.forEach(column => {
          rowData.push(
            this.grid.getDisplayedRowAtIndex(i)?.data[column.getColId()],
          )
        })
        data.push(rowData.join('\t'))
      }
      event.clipboardData?.setData(
        'text/plain',
        data.length > 1 ? data.join('\r\n') : data[0],
      )
      event.preventDefault()
    }
  }

  registerGrid(grid: GridApi) {
    this.grid = grid
    this.document.addEventListener('copy', this.copyBinding)
  }

  destroy() {
    this.document.removeEventListener('copy', this.copyBinding)
  }
}
